<template>
	<div id="app">
		<header class="container-fluid p-0 mb-5">
			<nav class="navbar navbar-expand-md navbar-light bg-light">
				<router-link to="/" class="navbar-brand"><img :src="retina('/images/logo.png')" style="width: 277px; height: 90px;" class="mw-100 h-auto" /></router-link>
				<button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
					<span class="navbar-toggler-icon"></span>
				</button>

				<div class="collapse navbar-collapse flex-row-reverse" id="navbarSupportedContent">
					<ul class="navbar-nav">
						<li class="nav-item">
							<em class="fas fa-2x loading mr-3"></em>
						</li>
						<li class="nav-item" v-if="logged_in">
							<router-link to="/" class="nav-link"><em class="fas fa-bus-alt"></em> My Seating Plans</router-link>
						</li>
						<li class="nav-item" v-if="logged_in && userHasAction(user, ['ADMIN'])">
							<router-link to="/users" class="nav-link"><em class="fas fa-users"></em> Users</router-link>
						</li>
						<li class="nav-item" v-if="logged_in && userHasAction(user, ['ADMIN'])">
							<router-link to="/groups" class="nav-link"><em class="fas fa-user-tag"></em> Groups</router-link>
						</li>
						<li class="nav-item" v-if="logged_in">
							<router-link to="/account" class="nav-link"><em class="fas fa-user-tie"></em> My Account</router-link>
						</li>
						<li class="nav-item" v-if="logged_in">
							<router-link to="/help" class="nav-link"><em class="fas fa-question-circle text-danger"></em> HELP!</router-link>
						</li>
						<li class="nav-item" v-if="logged_in">
							<router-link to="/logout" class="nav-link"><em class="fas fa-wind fa-flip-horizontal"></em><em class="fas fa-car-side"></em> Logout</router-link>
						</li>
					</ul>
				</div>
			</nav>
		</header>

		<div class="container mb-5"><router-view :logged_in="logged_in" :current_user="user" @login="login" @logout="logout" /></div>

		<footer class="container-fluid p-0 mb-3">
			<hr>
			<nav>
				<ul class="nav d-flex justify-content-center">
					<li class="nav-item">
						<router-link to="/" class="nav-link"><em class="fas fa-info-circle"></em> {{app_name}}</router-link>
					</li>
					<li class="nav-item" v-if="logged_in">
						<router-link to="/" class="nav-link"><em class="fas fa-bus-alt"></em> My Seating Plans</router-link>
					</li>
					<li class="nav-item" v-if="userHasAction(user, ['ADMIN'])">
						<router-link to="/users" class="nav-link"><em class="fas fa-users"></em> Users</router-link>
					</li>
					<li class="nav-item" v-if="logged_in">
						<router-link to="/account" class="nav-link"><em class="fas fa-user-tie"></em> My Account</router-link>
					</li>
					<li class="nav-item" v-if="logged_in">
						<router-link to="/logout" class="nav-link"><em class="fas fa-wind fa-flip-horizontal"></em><em class="fas fa-car-side"></em> Logout</router-link>
					</li>
				</ul>
			</nav>
		</footer>
	</div>
</template>


<script>
	export default
	{
		name: 'App',
		data() {
			return {
				logged_in: (this.getCookie("access_token_cookie") != ""),
				user: {user_id: null, roles: [], school_ids: "", operator_ids: ""}
			}
		},
		methods: {
			checkSession: function()
			{
				var vm = this;

				vm.CORS("GET", "/authenticate", "", function(response)
				{
					vm.user = response.user;
					vm.logged_in = true;
				},
				function()
				{
					// vm.logged_in = false;
					// vm.user = null;

					// if(vm.$route.path != "/login")
					// {
					// 	vm.$router.push("/login").catch(function() { /* ignore error */ });
					// }
				});
			},
			login: function()
			{
				this.logged_in = true;
			},
			logout: function()
			{
				this.user = {user_id: null, roles: []};
				this.logged_in = false;
			}
		},
		mounted: function()
		{
			var vm = this;

			document.getElementsByTagName("title")[0].innerHTML = vm.app_name + " Portal";

			vm.checkSession();
		},
		watch:
		{
			'$route' (to, from) {
				if(from.name == "Logout")
				{
					return;
				}

				this.checkSession();
			}
		}
	}
</script>

<style>
#app
{
	font-family: Avenir, Helvetica, Arial, sans-serif;
}
footer a
{
	color: inherit;
}
.fa-bus,
.fa-bus-alt
{
	color: rgb(255, 187, 68);
}
</style>
